import { useLocation } from 'react-router-dom';

export type TMarketingTabname = 'messages' | 'promotions' | 'bulk-notifications';

const useTabSelected = () => {
	const { pathname } = useLocation();
	const tabSelected = pathname.split('/').reverse()[0] as TMarketingTabname;
	const title =
		tabSelected === 'promotions'
			? 'Promotions'
			: tabSelected === 'bulk-notifications'
				? 'Notifications push'
				: 'Messages';

	return {
		tabSelected,
		title,
	};
};

export default useTabSelected;
